import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import DSIcon from '../../../base/DSIcon';

import { COST_TYPE_CUSTOM } from '../../constants/costs';

import PaymentTimelineCard from './PaymentTimelineCard';

const ICONS_DICTIONARY = {
  contractRegistration: 'check_circle_transparent',
  latePayment: 'verified_card',
  earlyDepartureNoticePeriodBroken: '',
  extraTenant: 'perfect_for_couples',
  overnightGuest: 'perfect_for_couples',
  petFee: 'pets_allowed',
  outOfHoursCheckIn: 'faster',
  outOfHoursCheckOut: 'faster',
  checkOutCleaning: 'cleaning_service',
  council: 'bank_court_house',
  local: 'private_landlord',
  building: 'cottage',
  laundry: 'washing_machine',
  streaming: 'tv',
  custom: 'diamond',
  periodicCleaning: 'cleaning_service',
  parking: 'private_parking',
  bedLinen: 'bed_linen',
  meal: 'meal_service'
};

const Extra = ({ costs = {}, currencyCode }) => {
  const handleCostClick = cost => () => {
    console.log(cost);
  };

  return costs?.costs?.length > 0 ? (
    <PaymentTimelineCard
      title={trans('payment.timeline.section.extra.title')}
      subtitle={trans('payment.timeline.section.extra.subtitle')}
      outlined={false}
      gapSpacing="big"
      tags={costs?.costs?.map(cost => ({
        label:
          cost.type === COST_TYPE_CUSTOM
            ? cost.name
            : trans(`payment.timeline.cost.label.${cost.type}`),
        renderLeadingIcon: () =>
          ICONS_DICTIONARY[cost.type] ? (
            <DSIcon name={ICONS_DICTIONARY[cost.type]} />
          ) : null,
        onClick: handleCostClick(cost),
        isSpaced: true,
        underlined: true,
        size: 'big',
        colorSchema: 'light'
      }))}
    />
  ) : null;
};

Extra.propTypes = {
  costs: PropTypes.shape({
    costs: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  currencyCode: PropTypes.string.isRequired
};

export default Extra;
